import { toolboxComponents } from "@client/components/PageSkeleton/Toolbox";
import { getTheme } from "@client/styles/themes";
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { ArticleHeroBlock } from "../components/ArticleHeroBlock";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (props: templates.ArticleDetailTemplate) => {
    return (
        <PageSkeleton
            {...props.page}
            breadcrumbs_theme={getTheme(props.page.body.value[0]?.value)}
        >
            <StreamField
                tagName={React.Fragment}
                components={{
                    ...toolboxComponents,
                    article_hero: (args) => (
                        <ArticleHeroBlock
                            {...args}
                            parentPage={props.page.articles_landing_page}
                        />
                    ),
                }}
                value={props.page.body.value}
            />
        </PageSkeleton>
    );
};
